
import { Component, Vue, Prop, Emit } from 'nuxt-property-decorator';
import Tooltip from './Tooltip.vue';

@Component({
  components: {
    Tooltip,
  },
})
export default class QuickMenuButton extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: String, required: true }) readonly icon!: string;
  @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly destructive!: boolean;
  @Prop({ type: String, default: undefined }) readonly ariaLabel?: string;
  @Prop({ type: Boolean, default: undefined }) readonly ariaPressed?: boolean;

  @Emit('click') emitClick(_event: PointerEvent): void {}
  @Emit('focus') emitFocus(_event: FocusEvent): void {}
  @Emit('blur') emitBlur(_event: FocusEvent): void {}
  @Emit('mousedown') emitMouseDown(_event: MouseEvent): void {}
  @Emit('mouseup') emitMouseUp(_event: MouseEvent): void {}
  @Emit('keydown') emitKeyDown(_event: KeyboardEvent): void {}
  @Emit('keypress') emitKeyPress(_event: KeyboardEvent): void {}
  @Emit('keyup') emitKeyUp(_event: KeyboardEvent): void {}

  get rootClassNames(): Record<string, boolean> {
    return {
      '-active': this.isActive,
      '-disabled': this.disabled,
      '-destructive': this.destructive,
    };
  }

  get tooltipDirective() {
    return {
      content: `<div class='tooltip'>${this.label}</div>`,
      html: true,
      distance: 12,
      placement: 'top',
      triggers: ['hover', 'focus'],
      popperTriggers: [],
      delay: { show: 25 },
      overflowPadding: 16,
      autoBoundaryMaxSize: true,
      noAutoFocus: true,
      disabled: this.disabled,
      theme: 'dropdown',
    };
  }

  get isAriaPressed(): boolean {
    return this.ariaPressed ?? this.isActive;
  }
}
